/* eslint-disable no-unused-vars */
import $ from 'jquery';
import Pikaday from 'pikaday';

const defaults = {
  firstDay: 1,
  position: 'bottom right',
  theme: 'netc-calendar-theme',
};

export default function calendar(fieldSelector, triggerSelector, options = {}) {
  const $date = $(selector);
  const $trigger = $(triggerSelector);

  const locals = {
    ...defaults,
    ...options,
  };

  locals.field = $date[0];
  locals.trigger = $trigger[0];

  if (!$date.length) {
    return;
  }

  if (!Modernizr.mq('(min-width: 1025px)')) {
    return;
  }

  return new Pikaday(locals);
}
